import React from 'react';
import { LockKeyholeIcon, MonitorSmartphoneIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CTAButton } from './Shared';
import { Bamboo, KanjiBackdrop, Mandala, Needle, YinYang } from './Ornaments';
const productMockupUrl = 'https://cdn.magicpatterns.com/uploads/6d7scZtSSWvGed8yXygC4i/Mockup_MTC.png';
const trustItems = [{
  icon: MonitorSmartphoneIcon,
  label: 'PDF para leer en computadora, tablet o celular'
}, {
  icon: ZapIcon,
  label: 'Acceso digital'
}, {
  icon: LockKeyholeIcon,
  label: 'Pago seguro con Mercado Pago'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}];
export function Hero() {
  const reduceMotion = useReducedMotion();
  return <header className="relative isolate overflow-hidden pb-8 pt-4 sm:pt-8 md:pb-14 lg:pt-10" data-id="element-79" data-mp="nbyh6zuyndcu">
      <KanjiBackdrop glyphs={['中', '醫', '氣', '陰', '陽']} data-id="element-80" data-mp="3d33cssqt6ji4" />
      <Mandala className="pointer-events-none absolute -right-24 top-2 -z-10 h-72 w-72 opacity-[0.1] md:right-4 md:h-96 md:w-96" color="#b45309" data-id="element-81" data-mp="381xiwrlewq70" />
      <Mandala className="pointer-events-none absolute -bottom-28 -left-28 -z-10 h-80 w-80 opacity-[0.08] md:h-[30rem] md:w-[30rem]" color="#047857" data-id="element-82" data-mp="3j9agbasosm43" />
      <Bamboo className="absolute left-[6%] top-52 hidden h-16 w-16 opacity-40 md:block" color="#047857" data-id="element-83" data-mp="39authk0ozz0e" />
      <Needle className="absolute right-[6%] top-60 hidden h-14 w-14 opacity-40 md:block" color="#92400e" data-id="element-84" data-mp="3e8mssz3o2nem" />

      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-85" data-mp="30gzu6sm952so">
        <motion.div initial={reduceMotion ? false : {
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-86" data-mp="3599ik47pxusu">
          <div className="mb-2 inline-flex items-center gap-2 rounded-full border border-stone-200 bg-white px-3 py-0.5 shadow-sm sm:mb-4 sm:px-4 sm:py-1.5" data-id="element-87" data-mp="2vjq0h0rty4z1">
            <YinYang className="h-3.5 w-3.5 sm:h-4 sm:w-4" color="#047857" data-id="element-88" data-mp="2lkiks6xmhy8r" />
            <span className="text-[10px] font-semibold tracking-[0.22em] text-stone-900 sm:text-xs" data-id="element-89" data-mp="2lmlasqyrzrdh">
              LUMEN AKASHA™
            </span>
          </div>

          <p className="hidden text-2xl text-amber-700/80 lg:block" aria-hidden="true" data-id="element-90" data-mp="najj9tbacnhn">
            中醫
          </p>
          <p className="mb-1.5 text-[11px] font-semibold tracking-[0.16em] text-emerald-700 sm:mb-3 sm:text-sm lg:mt-1 lg:text-base" data-id="element-91" data-mp="ichx2zikc81y">
            KIT MEDICINA TRADICIONAL CHINA™
          </p>
          <h1 className="mx-auto max-w-4xl text-[24px] font-semibold leading-[1.12] tracking-tight text-stone-900 sm:text-4xl md:text-5xl lg:text-[3.5rem]" data-id="element-92" data-mp="1b0duk6fyi3zs">
            ¿Querés seguir profundizando en{' '}
            <span className="font-bold text-red-700" data-id="element-93" data-mp="110wqftgcry5x">Medicina Tradicional China?</span>
          </h1>
          <p className="mx-auto mt-2 max-w-3xl text-[15px] font-semibold leading-snug text-stone-900 sm:mt-4 sm:text-xl lg:text-2xl" data-id="element-94" data-mp="x0ut1whnhqwg">
            Una Biblioteca de Estudio para Llevar tu Práctica al Siguiente Nivel
          </p>

          <div className="relative mx-auto -mt-2 w-full max-w-5xl sm:mt-0" data-id="element-95" data-mp="1x9kv8ohov8i9">
            <motion.img src={productMockupUrl} alt="Mockup del Kit Medicina Tradicional China: cuaderno principal, tomos de estudio y fichas" initial={reduceMotion ? false : {
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3,
            delay: reduceMotion ? 0 : 0.12,
            ease: [0.23, 1, 0.32, 1]
          }} className="mx-auto h-auto max-h-[52svh] w-auto max-w-full object-contain drop-shadow-xl sm:max-h-[58svh] lg:max-h-[66svh]" draggable={false} decoding="async" data-id="element-96" data-mp="1x786nshfdzw8" />
          </div>

          <div className="mt-1 flex flex-col items-center sm:mt-3" data-id="element-97" data-mp="2tzle66vdmurn">
            <CTAButton className="w-full max-w-[22rem] px-4 py-3.5 text-sm sm:w-auto sm:max-w-none sm:px-10 md:text-lg" data-id="element-98" data-mp="2tysfzuahhdl4">
              → QUIERO MI KIT MTC AHORA
            </CTAButton>
            <p className="mt-3 text-[11px] font-semibold uppercase tracking-[0.14em] text-amber-700 sm:text-sm" data-id="element-99" data-mp="zm2n9fvuqafb">
              6 tomos · 3 bonus gratuitos · 450 páginas · 100% PDF
            </p>
            <p className="mx-auto mt-5 max-w-3xl text-base leading-relaxed text-stone-600 sm:text-lg" data-id="element-100" data-mp="3vgvwyrmxhf5q">
              Explorá sus principales ramas en una biblioteca visual de estudio: fundamentos, Zang-Fu, diagnosis, acupuntura, digitopuntura, moxibustión, ventosas, guasha, Tuina y Qigong.
            </p>
            <ul className="mt-5 flex max-w-3xl flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-stone-600 md:text-sm" aria-label="Condiciones de compra" data-id="element-101" data-mp="3hqsbi2vvhphc">
              {trustItems.map(item => <li key={item.label} className="inline-flex items-center gap-1.5" data-id="element-102" data-mp="3rgvhr4s08zxm">
                  <item.icon className="h-4 w-4 text-emerald-700" aria-hidden="true" data-id="element-103" data-mp="3mp3lcdm63zzk" />
                  {item.label}
                </li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </header>;
}